export default __webpack_public_path__ + "static/media/grua-staker.f23aec55.png";